module.exports = "/images/placholder_1200.svg?eeda8f50af36686e3f677925b04de929";